import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

import { EmailNotifications } from './companyNotifications.types';
import { CompanyNotificationsResponseDto } from './companyNotifications.dto';

export class CompanyNotificationsApi extends HttpClient {
  public constructor() {
    super(`${process.env.REACT_APP_API_URL}/email-notifications`);
  }

  public async getAll(): Promise<CompanyNotificationsResponseDto> {
    return this.instance.get('').then((response: AxiosResponse<CompanyNotificationsResponseDto>) => response.data);
  }

  public async upsertMany(items: EmailNotifications[]): Promise<CompanyNotificationsResponseDto> {
    return this.instance.patch('', items).then((res: AxiosResponse<CompanyNotificationsResponseDto>) => res.data);
  }

  public async deleteById(id: number): Promise<void> {
    await this.instance.delete(`/${id}`);
  }
}
